import React from "react";
import { legendItems } from "./calendarStyles";
import useTranslation from "../../../../shared/hooks/useTranslation";
import { useBreakpoint } from "../../../../shared/hooks/useBreakpoint";

/**
 * #14, #15, #16, #33: Legend bar — sits ABOVE the calendar, not below.
 * 5 items only (Reactive, Preventive, Predictive, Inspection, General).
 * No "Recurring" item. Dots are 8px circles. Labels are uppercase 11px Sora.
 * WO-RESP-4: Tablet compact mode — smaller font, tighter gaps, scrollable overflow.
 */
const ScheduleLegend: React.FC = () => {
  const { translate } = useTranslation("operations");
  const { isTablet } = useBreakpoint();

  return (
    <div
      className={`wo-legend-scroll w-full px-8 py-2 flex items-center ${isTablet ? "gap-4" : "gap-5"}`}
      style={{
        overflowX: "auto",
        /* Hide scrollbar across browsers — safety net for narrow tablets */
        scrollbarWidth: "none",          /* Firefox */
        msOverflowStyle: "none" as any,  /* IE/Edge */
      }}
    >
      {/* Webkit scrollbar hide */}
      <style>{`
        .wo-legend-scroll::-webkit-scrollbar { display: none; }
      `}</style>
      {legendItems.map((item) => (
        <div key={item.typeId} className="flex items-center gap-1.5 flex-shrink-0">
          <div
            className="w-2 h-2 rounded-full flex-shrink-0"
            style={{ backgroundColor: item.color }}
          />
          <span
            className={`${isTablet ? "text-[10px]" : "text-[11px]"} font-normal uppercase tracking-[0.04em] text-mid-muted whitespace-nowrap`}
            style={{ fontFamily: "'Sora', sans-serif" }}
          >
            {translate(item.labelKey)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ScheduleLegend;
